import { type Location } from '@reliance/types/models/Location';
import { type ApiService } from '../types/ApiService';

export const location = (centralApi: ApiService) => ({
  getAniDetails: (ani): Promise<Location> => {
    return centralApi.get(`/location/ani-details/${ani}`);
  },
});
